import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ArrowLeft } from "lucide-react";

import CrossReportBanner from "./CrossReportBanner";
import DownloadPdfButton from "./DownloadPdfButton";
import PerceptionReport from "./PerceptionReport";
import PerceptionTrends from "./PerceptionTrends";

const TABS = ["Report", "Trends"];

const PerceptionVisibilityReport = ({ trendsOnly = false }) => {
  const { report_id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(trendsOnly ? "Trends" : "Report");

  /* ── Trends-only view (/perception/trends) ──────────────────────────── */
  if (trendsOnly) {
    return (
      <div className="min-h-screen pt-10 pb-16 px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          <button
            onClick={() => navigate("/perception")}
            className="flex items-center gap-2 text-sm text-on-surface-variant hover:text-primary transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to AI Perception
          </button>
          <PerceptionTrends />
        </div>
      </div>
    );
  }

  const renderTab = () => {
    switch (activeTab) {
      case "Report":
        return <PerceptionReport reportId={report_id} onReset={() => navigate("/perception")} />;
      case "Trends":
        return <PerceptionTrends />;
      default:
        return null;
    }
  };

  /* ── Full report view (/perception/report/:report_id) ───────────────── */
  return (
    <div className="min-h-screen pt-10 pb-16 px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Back */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate("/perception")}
            className="flex items-center gap-2 text-sm text-on-surface-variant hover:text-primary transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            New report
          </button>
          {activeTab === "Report" && (
            <DownloadPdfButton reportType="perception" reportId={report_id} />
          )}
        </div>

        {/* Tabs */}
        <div className="flex items-center justify-between gap-4 mb-8">
          <div className="flex gap-1 p-1 bg-surface-container-low rounded-xl border border-surface-container-high overflow-x-auto">
            {TABS.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`flex-1 whitespace-nowrap py-3 px-4 rounded-lg text-sm font-semibold transition-all ${
                  activeTab === tab
                    ? "bg-gradient-to-br from-primary to-primary-container text-on-primary shadow-lg"
                    : "text-on-surface-variant hover:text-on-surface hover:bg-surface-container-high"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Tab content */}
        {renderTab()}

        <CrossReportBanner currentReport="perception" />
      </div>
    </div>
  );
};

export default PerceptionVisibilityReport;
